module.exports = __webpack_public_path__ + "img/ci.e50f1c8d.svg";